// extracted by mini-css-extract-plugin
export default {"row2":"ExternalTable_row2__hx7ia","cards":"ExternalTable_cards__Xi5mE"};